import { render, staticRenderFns } from "./KeyValueTable.vue?vue&type=template&id=191b9e98&"
import script from "./KeyValueTable.vue?vue&type=script&lang=js&"
export * from "./KeyValueTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports